// extracted by mini-css-extract-plugin
export var container = "_fc-0";
export var icon = "_fc-1";
export var text = "_fc-2";